module.exports = __webpack_public_path__ + "static/media/bg-word.d5169c6b.png";